import { Backdrop as BackdropMUI } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import styled from 'styled-components';

export const Backdrop = styled(BackdropMUI)`
  z-index: 9999 !important;
  border-radius: 5px !important;

  & div {
    background: #ffffff !important;
    width: 50px !important;
    height: 50px !important;
    border-radius: 50px !important;
    padding: 10px !important;
  }
`;

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: rgba(0, 0, 0, 0.5);

  & div {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -25px !important;
    margin-top: -25px !important;
    background: #ffffff !important;
    width: 50px !important;
    height: 50px !important;
    border-radius: 50px !important;
    padding: 10px !important;
  }
`;

export const LoadingProgress = styled(CircularProgress)`
  padding: 0 !important;
  margin: 0 !important;

  * {
    color: ${({ theme, propcolor }) => propcolor || theme.colors.primary} !important ;
  }

  svg {
    margin: 0 !important;
    padding: 0 !important;
    width: ${({ size }) => size} !important;
    height: ${({ size }) => size} !important;
  }
`;

export default {};
